export default "__VITE_ASSET__DIY5boXA__"